import { Comparer } from '@common/services';
import { createSelector } from '@ngrx/store';
import { DateTime } from 'luxon';

import { Entity } from '@apps/auth/domain/models/back';

import { IBackAuthEntitiesState } from '../entities.state';
import { entitiesAdapter } from '../entities.common';
import { getBackAuthEntitiesState } from '../entities.selectors';
import { BackAuthEntitiesInternalFeatureKey, IBackAuthEntitiesInternalState } from './entities-internal.reducer';
import { BackConstants } from '@apps/back/back.constants';
import { filterQuickSearch } from '@common/services/utils.service';

export const getBackAuthEntitiesInternalState = createSelector(
    getBackAuthEntitiesState,
    (state: IBackAuthEntitiesState) =>
        state[BackAuthEntitiesInternalFeatureKey]
);

export const getEntitiesInternalCounters = createSelector(
    getBackAuthEntitiesInternalState,
    (state: IBackAuthEntitiesInternalState) =>
        state.counters
);

export const getEntitiesInternalQueryString = createSelector(
    getBackAuthEntitiesInternalState,
    (state: IBackAuthEntitiesInternalState) =>
        state.oData.qs
);
export const getBackAuthInternalEntitiesState = createSelector(
    getBackAuthEntitiesInternalState,
    (state: IBackAuthEntitiesInternalState) =>
        state.entities
);
export const {
    selectAll: getAllInternalEntities,
    selectTotal: getTotalInternalEntities,
} = entitiesAdapter.getSelectors(getBackAuthInternalEntitiesState);

const getQuickSearchedInternalEntities = createSelector(
    getBackAuthEntitiesInternalState,
    getAllInternalEntities,
    (state: IBackAuthEntitiesInternalState, entities: Entity[]) =>
        filterQuickSearch(entities, state.qsWord, BackConstants.entitiesQSFields)
);
export const getPipelinedEntitiesInternal = createSelector(
    getQuickSearchedInternalEntities,
    (entities: Entity[], params: { comparer: Comparer<Entity> }) =>
        [...entities].sort(params.comparer)
);
export const getEntitiesInternalLoadingStatus = createSelector(
    getBackAuthEntitiesInternalState,
    (state) => state.isLoading
);
export const getEntitiesInternalLoadedStatus = createSelector(
    getBackAuthEntitiesInternalState,
    (state) => state.isLoaded
);
export const getEntitiesInternalOupsStatus = createSelector(
    getBackAuthEntitiesInternalState,
    (state) => state.isOups
);
export const getEntitiesInternalEmptyStatus = createSelector(
    getBackAuthEntitiesInternalState,
    (state) => state.isEmpty
);
export const getEntitiesInternalIsDataValid = createSelector(
    getBackAuthEntitiesInternalState,
    (state) =>
        state.expirationDate !== null && DateTime.utc() < state.expirationDate
);
